
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"viewBox":"0 0 42 41","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"fill-rule":"evenodd","clip-rule":"evenodd","d":"M20.789 40.09c10.794 0 19.545-8.75 19.545-19.545C40.334 9.75 31.584 1 20.789 1 9.995 1 1.244 9.75 1.244 20.545c0 10.794 8.75 19.545 19.545 19.545z","fill":"#fff","stroke":"#E54852","stroke-width":"1.348"}}),_c('path',{attrs:{"fill-rule":"evenodd","clip-rule":"evenodd","d":"M18 17.037c0-1.67 1.343-3.022 3-3.022s3 1.353 3 3.022c0 1.669-1.343 3.022-3 3.022s-3-1.353-3-3.022zM21 12c2.761 0 5 2.255 5 5.037 0 1.648-.786 3.11-2 4.03v7.469L20.561 32l-4.431-3.72 1.62-2.176-1.5-2.015L18 21.74v-.672a5.042 5.042 0 01-2-4.03C16 14.255 18.239 12 21 12zm-1 9.973v.437l-1.25 1.68 1.5 2.014-1.38 1.854 1.569 1.316L22 27.701v-5.728a4.985 4.985 0 01-2 0z","fill":"#E54852"}}),_c('path',{attrs:{"stroke":"#E54852","d":"M6.674 33.621l28.999-25"}})])
          )
        }
      }
    